import { motion } from "framer-motion";
import { MANIFESTO } from "@/data/content";
import { HeartHandshake, Sparkles, Stethoscope, MapPin } from "lucide-react";

const ICONS = [HeartHandshake, Stethoscope, Sparkles, MapPin];

export default function Manifesto() {
  return (
    <section id="story" className="py-20 md:py-32" data-testid="manifesto">
      <div className="max-w-[1440px] mx-auto px-5 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-10 items-end mb-10 md:mb-14">
          <div className="col-span-12 md:col-span-6">
            <div className="eyebrow mb-4">Our approach</div>
            <h2 className="font-display text-3xl md:text-5xl lg:text-[3.2rem] leading-[1.05] tracking-[-0.02em]">
              A calmer take on <span className="hl text-[hsl(var(--primary))]">dental care</span> in Mumbai.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8">
            <p className="text-[hsl(var(--ink-soft))] leading-relaxed">
              Four ideas that shape how we treat every patient — from your first cleaning to a full-mouth reconstruction.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {MANIFESTO.map((m, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.article
                key={m.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                className="card-soft p-6 md:p-8"
                data-testid={`manifesto-chapter-${m.n}`}
              >
                <div className="w-12 h-12 rounded-2xl bg-[hsl(var(--primary-light))] text-[hsl(var(--primary-dark))] flex items-center justify-center mb-6">
                  <Icon size={22} strokeWidth={1.7} />
                </div>
                <div className="font-mono text-xs text-[hsl(var(--primary))] mb-2">0{i + 1}</div>
                <h3 className="font-display text-xl leading-tight mb-3">{m.title}</h3>
                <p className="text-[14px] text-[hsl(var(--ink-soft))] leading-relaxed">{m.body}</p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
